import React from 'react';
import 'dayjs/locale/pt';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useRecoilValue } from 'recoil';
import { languageAtom } from 'atoms';

function DatePickersLocalizationProvider({ children }: { children: React.ReactNode }) {
  const language = useRecoilValue(languageAtom);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={language}>
      {children}
    </LocalizationProvider>
  );
}

export default DatePickersLocalizationProvider;
